import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWalkNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M9.17 24.17H5.83v1.66h3.34zm5 0h-3.34v1.66h3.34zm5 0h-3.34v1.66h3.34z" />
        <path d="M28.25 16.17h-2.52l-9.99-5.32-2.49-4.68h-1.37a2.719 2.719 0 00-2.71 2.71v1.37l-1.38 2.58a.67.67 0 01-1.13.02l-.71-1.23a2.682 2.682 0 00-2.38-1.45h-2.4v10.22l-.08.09a3.132 3.132 0 002.22 5.35h.86v-1.66h-.86a1.486 1.486 0 01-1.21-2.34h12.07v-1.66H2.83v-8.34h.74a1.058 1.058 0 01.94.58l.72 1.26a2.293 2.293 0 004.02-.06l1.58-2.95V8.88a1.05 1.05 0 011.05-1.05h.38l2.26 4.24 1 .54-1.11 2.09 1.46.77 1.11-2.09 1.93 1.03-1.11 2.1 1.46.77 1.11-2.09 1.91 1.02-1.11 2.1 1.45.78 1.12-2.1 1.58.84h2.93a1.92 1.92 0 011.92 1.92 2.374 2.374 0 01-.7 1.7 9.243 9.243 0 01-6.58 2.72h-2.06v1.66h2.06a10.91 10.91 0 007.75-3.22 4.032 4.032 0 001.19-2.86 3.589 3.589 0 00-3.58-3.58z" />
      </g>
    </svg>
  )
);
SvgSportsWalkNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsWalkNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWalkNormalMedium;
